module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-02.d79f1ad3.svg";